import InputIcon from 'components/Input/InputPartials/InputIcon';
import styled from 'styled-components';

const BooleanInputIcon = styled(InputIcon)`
  margin-left: 16px;
`;

export default BooleanInputIcon;
